export const ADDBOOKING = "booking/addbooking";
export const DELETEBOOKING = "booking/deletebooking";
